import { View } from "react-native";
import { MoonSkeleton } from "@louise/moon-ui";
import { GLASS_CARD_STYLE } from "@louise/moon-ui/theme/tokens";

function SkeletonRow({ isFirst = false }: { isFirst?: boolean }) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 16,
        paddingVertical: 14,
        borderTopWidth: isFirst ? 0 : 1,
        borderTopColor: "#F0EBE5",
        gap: 14,
      }}
    >
      <MoonSkeleton width={28} height={28} circle />
      <MoonSkeleton width={120} height={15} style={{ flex: 1 }} />
      <MoonSkeleton width={60} height={14} />
    </View>
  );
}

export default function YouScreenSkeleton() {
  return (
    <View style={{ paddingHorizontal: 20, paddingTop: 52, gap: 20 }}>
      {/* Avatar placeholder */}
      <View style={{ alignItems: "center", marginBottom: 8 }}>
        <MoonSkeleton width={80} height={80} circle />
        <MoonSkeleton
          width={140}
          height={20}
          radius={8}
          style={{ marginTop: 12 }}
        />
        <MoonSkeleton width={100} height={14} style={{ marginTop: 6 }} />
      </View>

      {/* Passport section */}
      <View>
        <MoonSkeleton width={100} height={11} style={{ marginBottom: 12 }} />
        <View
          style={{
            ...GLASS_CARD_STYLE,
            borderRadius: 14,
            padding: 16,
            flexDirection: "row",
            gap: 14,
          }}
        >
          {[1, 2, 3, 4].map((i) => (
            <MoonSkeleton key={i} width={56} height={56} circle />
          ))}
        </View>
      </View>

      {/* Your Info section */}
      <View>
        <MoonSkeleton width={80} height={11} style={{ marginBottom: 12 }} />
        <View
          style={{
            backgroundColor: "#FFFFFF",
            borderRadius: 12,
            borderWidth: 1,
            borderColor: "#F0EBE5",
          }}
        >
          <SkeletonRow isFirst />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
        </View>
      </View>

      {/* Settings section */}
      <View>
        <MoonSkeleton width={70} height={11} style={{ marginBottom: 12 }} />
        <View
          style={{
            backgroundColor: "#FFFFFF",
            borderRadius: 12,
            borderWidth: 1,
            borderColor: "#F0EBE5",
          }}
        >
          <SkeletonRow isFirst />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
        </View>
      </View>
    </View>
  );
}
